import Modal, { ModalHeader, ModalPanel } from 'components/common/Modal'
import RedeemPromo from './account/RedeemPromo'
import RedeemGiftCard from './account/RedeemGiftCard'
import { useInvalidateUsers } from '@tovala/browser-apis-combinedapi'

const RedeemGiftCardPromoModal = ({
  userID,
  onCloseModal,
}: {
  userID: number
  onCloseModal: () => void
}) => {
  const { invalidateUserV1 } = useInvalidateUsers()

  const handleSuccess = () => {
    onCloseModal()

    invalidateUserV1(userID)
  }

  return (
    <Modal onCloseModal={onCloseModal}>
      <ModalPanel>
        <div className="w-[500px] sm:w-full">
          <ModalHeader onClickClose={onCloseModal}>
            <span className="block text-base uppercase">
              Redeem Gift Card/Promo
            </span>
          </ModalHeader>
          <div className="space-y-6 p-6 sm:p-4">
            <RedeemGiftCard onSuccess={handleSuccess} userID={userID} />
            <RedeemPromo onSuccess={handleSuccess} userID={userID} />
          </div>
        </div>
      </ModalPanel>
    </Modal>
  )
}

export default RedeemGiftCardPromoModal
